




















































import { Component, Prop, Vue } from "vue-property-decorator";
const $ = require("jquery");
window.$ = window.jQuery = $;

require("@/assets/js/jqBootstrapValidation.js");

@Component
export default class Contact extends Vue {
  formData = {
    name: undefined,
    mail: undefined,
    phone: undefined,
    message: undefined
  };

  data() {
    return {
      formData: {
        name: undefined,
        mail: undefined,
        phone: undefined,
        message: undefined
      }
    };
  }

  mounted() {
    $(document).ready(() => {
      $("#contactForm input,#contactForm textarea").jqBootstrapValidation({
        preventSubmit: true,
        submitError: function($form: any, event: any, errors: any) {
          // additional error messages or events
        },
        submitSuccess: ($form: any, event: any) => {
          event.preventDefault(); // prevent default submit behaviour
          const name = this.formData.name || "";
          const msgBtn = $("#sendMessageButton");
          // $("#a-contact-modal").trigger("click");
          msgBtn.prop("disabled", true); // Disable submit button until AJAX call is complete to prevent duplicate messages
          this.$store
            .dispatch("sendMessage", this.formData)
            .then(data => {
              console.log(data);
              // $("#contact-modal p.mb-5").html(data)
              $("#success").html("<div class='alert alert-success'>");
              $("#success > .alert-success")
                .html(
                  "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;"
                )
                .append("</button>");
              $("#success > .alert-success").append(
                "<strong>Su mensaje ha sido enviado.</strong>"
              );
              $("#success > .alert-success").append("</div>");
            })
            .catch(err => {
              console.log(err);
              $("#success").html("<div class='alert alert-danger'>");
              $("#success > .alert-danger")
                .html(
                  "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;"
                )
                .append("</button>");
              $("#success > .alert-danger").append(
                $("<strong>").text(
                  "Parece haber un problem con el envío de mensajes. Trate de nuevo después."
                )
              );
              $("#success > .alert-danger").append("</div>");
            })
            .then(() => {
              //clear all fields
              $("#contactForm").trigger("reset");
              setTimeout(() => {
                msgBtn.prop("disabled", false); // Re-enable submit button when AJAX call is complete
                $.magnificPopup.close();
              }, 1000);
            });
        },
        filter: function() {
          return $(this).is(":visible");
        }
      });
    });
  }
}
